<template>
    <div class="editar-eleccion">
        <br />
        <div class="form-group">
            <v-text-field
                v-model="description"
                hide-details="auto"
                label="Descripción"
            >
            </v-text-field>
        </div>
        <div class="form-group">
            <label class="form-label">
                Inicio
            </label>
            <Datetime
                v-model="start"
                class="eleccion-date"
                type="datetime"
            ></Datetime>
        </div>
        <div class="form-group">
            <label class="form-label">
                Fin
            </label>
            <Datetime
                v-model="end"
                class="eleccion-date"
                type="datetime"
            ></Datetime>
        </div>
        <br />
        <div class="form-group">
            <v-select
                v-model="typeSelected"
                disabled
                :items="types"
                label="Tipo de elección"
            >
            </v-select>
        </div>
        <br />

        <div>
            <v-btn :disabled="isLoading" class="form-btn" @click="editElection">
                <span v-if="isLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                </span>
                <template v-else>
                    Editar Eleccion
                </template>
            </v-btn>
        </div>
    </div>
</template>

<script>
import 'vue-datetime/dist/vue-datetime.css';
import { Datetime } from 'vue-datetime';
import { DateTime } from 'luxon';

import { mapActions } from 'vuex';

export default {
    components: {
        Datetime,
    },
    props: {
        election: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            start: new Date().toISOString(),
            end: DateTime.now()
                .plus({ days: 1 })
                .toISODate(),
            typeSelected: 'alumnos',
            description: '',
            fetchingElectionTypes: false,
            types: [],
        };
    },
    methods: {
        ...mapActions({
            _fetchElection: 'elecciones/fetchElection',
            _fetchElectionTypes: 'elecciones/fetchElectionTypes',
        }),
        fetchElection() {
            this.isLoading = true;
            this._fetchElection(this.election.id)
                .then(response => {
                    console.log({ response });
                    this.typeSelected = response.election_type_id;
                    this.start = response.start_date;
                    this.end = response.end_date;
                    this.description = response.description;
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => (this.isLoading = false));
        },
        fetchElectionTypes() {
            this.fetchingElectionTypes = true;

            this._fetchElectionTypes()
                .then(electionTypes => {
                    this.fetchingElectionTypes = false;

                    this.types = electionTypes.map(type => {
                        return {
                            value: type.id,
                            text: type.name,
                        };
                    });

                    if (this.types.length > 0) {
                        this.typeSelected = this.types[0].value;
                    }
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                });
        },
        editElection() {
            this.isLoading = true;
            const { start, end, description } = this;

            const data = {
                start_date: start,
                end_date: end,
                description: description,
                election_id: this.election.id,
            };

            console.log(data);

            this.$store
                .dispatch('elecciones/editElection', data)
                .then(electionUpdated => {
                    if (electionUpdated) {
                        this.$emit('hide');
                        this.description = '';
                        this.start = new Date().toISOString();
                        this.end = new Date().toISOString();
                    }
                })
                .catch(error => {
                    this.$store.dispatch('errorMessage', error);
                })
                .finally(() => (this.isLoading = false));
        },
    },
    mounted() {
        this.fetchElection();
        this.fetchElectionTypes();
    },
};
</script>

<style lang="scss" scoped>
.editar-eleccion {
    width: 100%;
}

.form-group {
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 0 5px;
    margin: 15px 0;

    .form-label {
        width: 100%;
    }
}

.form-control {
    width: 100%;
    display: block;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.eleccion-date {
    width: 100%;

    & deep .vdatetime-input {
        width: 100%;
        display: block;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
}

.form-btn {
    margin: 5px;
    padding: 10px;
}
</style>
